export class PatTipoBemModel {
 patTipoBemId? :number =  0;
 patGrupoId? :number =  0;
 ordem? :number =  0;
 codigo? :string =  '';
 descricao? :string =  '';
 observacao? :string =  '';
}
